import {
  GET_ICONS,
  GET_ICONS_FAILED,
  GET_ICONS_SUCCESS,
  GET_PLATFORM_SETTINGS,
  GET_PLATFORM_SETTINGS_FAILED,
  GET_PLATFORM_SETTINGS_SUCCESS,
  GET_SOCIAL_PROFILE_SETTINGS,
  GET_SOCIAL_PROFILE_SETTINGS_FAILED,
  GET_SOCIAL_PROFILE_SETTINGS_SUCCESS,
  GET_WEBSITE_CONFIGS,
  GET_WEBSITE_CONFIGS_FAILED,
  GET_WEBSITE_CONFIGS_SUCCESS,
  UPDATE_PLATFORM_SETTINGS,
  UPDATE_PLATFORM_SETTINGS_FAILED,
  UPDATE_PLATFORM_SETTINGS_SUCCESS,
  UPDATE_SOCIAL_PROFILE_SETTINGS_SUCCESS,
  UPDATE_WEBSITE_CONFIGS,
  UPDATE_WEBSITE_CONFIGS_FAILED,
  UPDATE_WEBSITE_CONFIGS_SUCCESS,
} from "./actionTypes"

const INITIAL_STATE = {
  loading: false,
  error: "",
  platformSettings: null,
  icons: [],
  socialProfileSettings: null,
  websiteConfigs: null,
}

const PlatformSettings = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_PLATFORM_SETTINGS:
    case UPDATE_PLATFORM_SETTINGS:
    case GET_ICONS:
    case GET_SOCIAL_PROFILE_SETTINGS:
    case GET_WEBSITE_CONFIGS:
    case UPDATE_WEBSITE_CONFIGS:
      return {
        ...state,
        loading: true,
      }
    case GET_PLATFORM_SETTINGS_FAILED:
    case UPDATE_PLATFORM_SETTINGS_FAILED:
    case GET_ICONS_FAILED:
    case GET_SOCIAL_PROFILE_SETTINGS_FAILED:
    case GET_WEBSITE_CONFIGS_FAILED:
    case UPDATE_WEBSITE_CONFIGS_FAILED:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }
    case GET_PLATFORM_SETTINGS_SUCCESS:
    case UPDATE_PLATFORM_SETTINGS_SUCCESS:
      return {
        ...state,
        platformSettings: action.payload,
        loading: false,
      }
    case GET_ICONS_SUCCESS:
      return {
        ...state,
        icons: action.payload,
        loading: false,
      }
    case GET_SOCIAL_PROFILE_SETTINGS_SUCCESS:
      return {
        ...state,
        socialProfileSettings: action.payload,
        loading: false,
      }
    case UPDATE_SOCIAL_PROFILE_SETTINGS_SUCCESS:
      return {
        ...state,
        socialProfileSettings: {
          ...state.socialProfileSettings,
          fields_to_display: action.payload?.fields_to_display,
          required_fields: action.payload?.required_fields,
        },
      }
    case GET_WEBSITE_CONFIGS_SUCCESS:
    case UPDATE_WEBSITE_CONFIGS_SUCCESS:
      return {
        ...state,
        websiteConfigs: action.payload,
        loading: false,
      }
    default:
      return state
  }
}

export default PlatformSettings
